import { Alert, Snackbar } from '@mui/material';
import React, { useContext } from 'react';


const NotifyContext = React.createContext({} as any);

export interface NotifyProps {
    message?: string
    type?: 'success' | 'info' | 'warning' | 'error'
}

export const NotifyProvider = (props: any) => {
    let [notify, setNotify] = React.useState<NotifyProps>({});

    const error = (message: string) => {
        setNotify({ type: 'error', message })
    }

    const success = (message: string) => {
        setNotify({ type: 'success', message })
    }

    const warn = (message: string) => {
        setNotify({ type: 'warning', message })
    }

    const info = (message: string) => {
        setNotify({ type: 'info', message })
    }

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setNotify({ ...notify, message: '' });
    };
    return (
        <NotifyContext.Provider value={{ error, success, warn, info }}>
            {props.children}
            <Snackbar open={notify.message ? true : false} autoHideDuration={4000} onClose={handleClose}>
                <Alert variant="filled" onClose={handleClose} severity={notify.type}>
                    {notify.message}
                </Alert>
            </Snackbar>
        </NotifyContext.Provider>
    )
}

export const useNotify = () => {
    return useContext(NotifyContext);
}